module.exports = __webpack_public_path__ + "img/office4.0e96985e.jpg";